import React, {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
  writeBatch,
} from 'firebase/firestore'
import db, {storage} from '../../../../services/firebase'
import {useAuth} from '../../../modules/auth'
import UploadFile from './UploadFile'
import {deleteObject, ref} from 'firebase/storage'
import AddTask from '../../controls/components/submodal/AddTask'
import {ToastContainer} from 'react-toastify'
import {Helmet} from 'react-helmet'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import ConfirmationModal from 'app/components/ConfirmationModal'
import Deactivate from 'app/components/Deactivate'
import Button from 'app/components/Button'
import useAuditContext from 'app/Hooks/useAuditContext'
import OwnerDisplay from 'app/components/OwnerDisplay'
import DocumentViewerModal from 'app/components/DocumentViewerModal'
import FormatTimestamp from 'app/components/FormatTimestamp'
import {evaluateTest} from '../../../Integrations/services/integrationTestsService'
import ControlSection from './viewTestsComponents/ControlSection'

const DetailsTest = () => {
  const {id} = useParams()
  const [personnels, setPersonnels] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [isRefreshingTest, setIsRefreshingTest] = useState(false)
  const [tests, setTests] = useState<any[]>([])
  const [selectedTest, setSelectedTest] = useState<any | null>(null)
  const [policies, setPolicies] = useState([] as any[])
  const [showUploadFile, setShowUploadFile] = useState(false)
  const [fileData, setFileData] = useState<File[]>([])
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [newOwner, setNewOwner] = useState('')
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>(undefined)
  const [activeTab, setActiveTab] = useState('overview')
  const [noteInput, setNoteInput] = useState('')
  const [tasks, setTasks] = useState<any[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [allTaskMarkAsCompleted, setAllMarkAsCompleted] = useState(false)
  const [editingNoteIndex, setEditingNoteIndex] = useState(null)
  const [editedNoteContent, setEditedNoteContent] = useState('')
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedFile, setSelectedFile] = useState<any>(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isNoteDeleteModalOpen, setIsNoteDeleteModalOpen] = useState(false)
  const [selectedNoteIndex, setSelectedNoteIndex] = useState<number | null>(null)
  const [isDeactivateOpen, setIsDeactivateOpen] = useState(false)
  const [isTestModalOpen, setIsTestModalOpen] = useState(false)
  const [isProcessingTest, setIsProcessingTest] = useState(false)
  const [noteSaving, setNoteSaving] = useState(false)
  const [audits, setAudits] = useState<any[]>([])
  const [isAdding, setIsAdding] = useState(false)
  const [isDocumentViewerOpen, setIsDocumentViewerOpen] = useState(false)
  const [selectedDocument, setSelectedDocument] = useState<any>(null)
  const [isTaskRemoveModalOpen, setIsTaskRemoveModalOpen] = useState(false)
  const [taskToRemove, setTaskToRemove] = useState<string | null>(null)
  const [isRemovingTask, setIsRemovingTask] = useState(false)
  
  const {currentAuditContext} = useAuditContext()

  const findOwnerUid = (ownerName: string) => {
    const selectedOwner = personnels.find(owner => owner.full_name === ownerName)
    return selectedOwner?.uid || selectedOwner?.id || ""
  }

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          end_date: doc.data().end_date,
        }))
        .filter((data) => !data.end_date)
      setPersonnels(risksData)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    getTests()
  }, [])

  useEffect(() => {
    getActiveFramworks()
  }, [])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'audits')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      let Data = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          status: doc.data()?.status,
          createdAt: doc.data().createdAt,
          auditor: doc.data().auditor,
        }))
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .filter((audit) => audit.status === 'Ongoing')

      if (currentUser?.role === 'Auditor') {
        Data = Data.filter((audit) => {
          if (!audit.auditor) return false
          
          if (Array.isArray(audit.auditor)) {
            return audit.auditor.some(auditor => 
              auditor.id === currentUser?.uid || auditor.email === currentUser?.email
            )
          } else {
            return audit.auditor.id === currentUser?.uid || audit.auditor.email === currentUser?.email
          }
        })
        setAudits(Data)
      }

      if (currentAuditContext) {
        Data = Data.filter((audit) => audit.id === currentAuditContext.auditId)
        setAudits(Data)
      }
    })
    setAudits([])
    return unsubscribe
  }, [currentAuditContext, currentUser])

  const getTests = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'tests')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const testsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setTests(testsData)

        const filteredEvidences = testsData.filter((evidence) => evidence.id === id)

        setSelectedTest(filteredEvidences || [])
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
      setSelectedTest([])
    }
  }

  const getActiveFramworks = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)

      const testsCollectionRef = collection(tenantRef, 'active_frameworks')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          frameworks: doc.data().frameworks,
        }))
        const frameworks = frameworksData[0]?.frameworks || []
        setActiveFrameworks(frameworks)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting tests:', error)
    }
  }

  useEffect(() => {
    getActivities()
  }, [])

  const getActivities = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const controlsCollectionRef = collection(tenantRef, 'tasklists')
      var activeTaskListsQuery = query(controlsCollectionRef, where('test_id', '==', id))
      const unsubscribe = onSnapshot(activeTaskListsQuery, (snapshot) => {
        const controlsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setTasks(controlsData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }

  useEffect(() => {
    try {
      const unsubscribe = onSnapshot(collection(db, 'PolicyManagement'), (snapshot) => {
        const testsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          policy: doc.data().policy,
        }))
        const filteredEvidences = testsData
        setPolicies(filteredEvidences)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting tests:', error)
    }
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(
          collection(db, 'BackgroundCheck_onboarding'),
          where('tenantId', '==', currentUser?.tenantId),
          where('uid', '==', currentUser?.uid)
        )

        const querySnapshot = await getDocs(q)
        querySnapshot.forEach((doc) => {
          const avatarUrl = doc.data()?.avatarUrl
          setAvatarUrl(avatarUrl)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [currentUser?.tenantId, currentUser?.uid])

  const handleOwner = async (event) => {
    const selectedOwner = event.target.value
    setNewOwner(selectedOwner)

    try {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tests/${id}`)
      await updateDoc(testDocRef, {
        owner: selectedOwner,
        owner_uid: findOwnerUid(selectedOwner),
      })
    } catch (error) {
      console.error('Error assigning owner: ', error)
    }
  }

  const handleFileUpload = (files: File[] | null) => {
    if (files && files.length > 0) {
      setFileData((prevFiles) => [...prevFiles, ...files])
    }
  }
  const handleAddFileClick = () => {
    setShowUploadFile(true)
  }

  const handleViewClick = (file) => {
    setSelectedDocument(file)
    setIsDocumentViewerOpen(true)
    setDropdownVisible(false)
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }
  const handleDownloadClick = async (file) => {
    try {
      const fileUrl = file.url
      const response = await fetch(fileUrl)
      const fileContent = await response.blob()
      const blob = new Blob([fileContent], {type: 'application/octet-stream'})
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `${file.name}`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(blobUrl)
      setDropdownVisible(false)
    } catch (error) {
      console.error('Error downloading policy file:', error)
    }
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return `${date.getDate()} ${date.toLocaleString('default', {
      month: 'long',
    })}, ${date.getFullYear()}`
  }

  const handleDeleteClick = (file) => {
    setSelectedFile(file)
    setIsDeleteModalOpen(true)
  }

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true)
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tests/${id}`)
      const docSnapshot = await getDoc(testDocRef)

      if (docSnapshot.exists()) {
        const data = docSnapshot.data()
        const updatedFiles = data.files.filter((f) => f.name !== selectedFile.name)
        const fileRef = ref(storage, selectedFile.url)
        await deleteObject(fileRef)
        await updateDoc(testDocRef, {files: updatedFiles})
        showSuccessToast({message: `"${selectedFile?.name}" has been deleted.`})
      } else {
        console.error('Document does not exist.')
      }
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the file.'})
    } finally {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
      setDropdownVisible(false)
    }
  }

  const handleMarkAsCompleteClicked = async (taskId: string, status: boolean) => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tasklists/${taskId}`)
      await updateDoc(testDocRef, {
        checked: status,
      })
      getActivities()
    } catch (error) {
      console.log(error)
    }
  }

  const handleNotes = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!noteInput.trim()) {
      return
    }

    const currentDate = new Date()

    const day = currentDate.getDate()
    const month = currentDate.toLocaleString('default', {month: 'long'})
    const year = currentDate.getFullYear()
    const formattedDate = `${day} ${month}, ${year}`

    let hours = currentDate.getHours()
    let minutes = currentDate.getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'

    // Round minutes to nearest 12
    minutes = Math.round(minutes / 12) * 12
    if (minutes === 60) {
      minutes = 0
      hours += 1
    }

    hours = hours % 12
    hours = hours ? hours : 12

    const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`

    try {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tests/${id}`)

      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []
      const assignedAuditId = currentAuditContext?.auditId || (currentUser?.role === 'Auditor' && audits.length > 0 ? audits[0]?.id : '')
      
      const newNoteObject = {
        addedUser: currentUser?.userName || 'Unknown User',
        addedUserUid: currentUser?.uid || '',
        addedDate: formattedDate,
        addedTime: formattedTime,
        note: noteInput.trim(),
        auditId: assignedAuditId,
      }

      const updatedNotes = [newNoteObject, ...currentNotes]
      setIsAdding(true)
      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })
      setIsAdding(false)
      setNoteInput('')
    } catch (error) {
      setIsAdding(false)
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleRemoveTask = (taskId) => {
    setTaskToRemove(taskId)
    setIsTaskRemoveModalOpen(true)
  }

  const handleConfirmTaskRemove = async () => {
    if (!taskToRemove) return
    
    try {
      setIsRemovingTask(true)
      const tenantId = currentUser?.tenantId || ''
      const taskRef = doc(db, 'tenants', tenantId, 'tasklists', taskToRemove)
      await deleteDoc(taskRef)
      getActivities()
      showSuccessToast({message: 'Selected items have been removed.'})
      setIsTaskRemoveModalOpen(false)
      setTaskToRemove(null)
    } catch (error) {
      showErrorToast({message: 'An error occurred while removing the selected items.'})
    } finally {
      setIsRemovingTask(false)
    }
  }

  const handleAllMarkAsCompleteClicked = async () => {
    var status = !allTaskMarkAsCompleted
    setAllMarkAsCompleted(status)
    try {
      const tenantId = currentUser?.tenantId || ''
      const taskListsRef = collection(db, `tenants/${tenantId}/tasklists`)
      const q = query(taskListsRef, where('test_id', '==', id))
      const querySnapshot = await getDocs(q)
      const batch = writeBatch(db)
      querySnapshot.forEach((doc) => {
        batch.update(doc.ref, {checked: status})
      })
      await batch.commit()
      getActivities()
    } catch (error) {
      console.log(error)
    }
  }

  const handleEditNote = (index, currentContent) => {
    setEditingNoteIndex(index)
    setEditedNoteContent(currentContent)
  }

  const handleDeleteNote = (index: number) => {
    setSelectedNoteIndex(index)
    setIsNoteDeleteModalOpen(true)
  }

  const handleConfirmNoteDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedNoteIndex === null) return

      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tests/${id}`)

      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []
      const updatedNotes = currentNotes.filter((_, i) => i !== selectedNoteIndex)

      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })
      showSuccessToast({message: 'Note has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the note.'})
    } finally {
      setIsDeleting(false)
      setIsNoteDeleteModalOpen(false)
      setSelectedNoteIndex(null)
    }
  }

  const handleSaveEditedNote = async () => {
    try {
      setNoteSaving(true)
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/tests/${id}`)
      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []

      const updatedNotes = currentNotes.map((note, index) =>
        index === editingNoteIndex ? {...note, note: editedNoteContent} : note
      )

      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })
      showSuccessToast({message: 'Note has been updated successfully.'})
      setEditingNoteIndex(null)
      setEditedNoteContent('')
      setNoteSaving(false)
    } catch (error) {
      console.error('Error editing note: ', error)
      setNoteSaving(false)
    }
  }

  const handleOpenTestModal = (test: any) => {
    // setSelectedTest(test)
    setIsTestModalOpen(true)
  }

  const handleCloseTestModal = () => {
    setIsTestModalOpen(false)
    // setSelectedTest([])
  }

  const handleDeactivateClick = () => {
    setIsDeactivateOpen(true)
  }

  const handleDeactivateClose = () => {
    setIsDeactivateOpen(false)
  }

  const handleConfirmTestActivateDeactivate = async () => {
    if (!selectedTest || !selectedTest[0]) return

    setIsProcessingTest(true)

    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId) {
        throw new Error('Tenant ID not found')
      }

      const docRef = doc(db, `tenants/${tenantId}/tests/${id}`)
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists()) {
        throw new Error('Test document not found')
      }

      const updateData = {
        status:
          selectedTest[0].type === 'Document' && selectedTest[0].files?.length > 0
            ? 'Pass'
            : 'Fail',
        deactivation_reason: '',
      }

      await updateDoc(docRef, updateData)
      setIsProcessingTest(false)
      setIsTestModalOpen(false)
      showSuccessToast({
        message: `Test ${updateData.status === 'Pass' ? 'activated' : 'updated'} successfully!`,
      })
    } catch (error) {
      console.error('Error updating test:', error)
      setIsProcessingTest(false)
      showErrorToast({message: `Failed to update test status`})
    }
  }

  const handleRefreshTest = async () => {
    if (!selectedTest || !selectedTest[0] || !currentUser?.tenantId) {
      return
    }

    setIsRefreshingTest(true)
    try {
      const tenantRef = doc(db, 'tenants', currentUser.tenantId)
      const integrationsRef = collection(tenantRef, 'integrations')
      const integrationQuery = query(integrationsRef, where('integration_name', '==', selectedTest[0].integration))
      const integrationSnapshot = await getDocs(integrationQuery)
      
      if (integrationSnapshot.empty) {
        showErrorToast({message: 'Integration not found'})
        return
      }

      const integrationData = integrationSnapshot.docs[0].data()
      
      const result = await evaluateTest(selectedTest[0].test_id, currentUser.tenantId, integrationData, currentUser?.uid || '')
      
      const testDocRef = doc(db, `tenants/${currentUser.tenantId}/tests/${id}`)
      await updateDoc(testDocRef, {
        status: result.status,
        updated_at: new Date().toISOString(),
        last_evaluation: result
      })

      showSuccessToast({message: 'Test refreshed successfully'})
    } catch (error) {
      console.error('Error refreshing test:', error)
      showErrorToast({message: 'Failed to refresh test'})
    } finally {
      setIsRefreshingTest(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Tests</title>
      </Helmet>
      {Array.isArray(selectedTest) && selectedTest.length > 0 ? (
        selectedTest.map((test) => (
          <>
            <div className='card px-6 pt-6 mb-4'>
              <div>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                  <div>
                    <h3 className='mb-2'>{test.name}</h3>
                    <div>
                      {test.framework
                        .split(', ')
                        .filter((framework) =>
                          activeFrameworks.some((item) => framework.startsWith(item))
                        )
                        .map((framework, index) => (
                          <span
                            key={index}
                            className='badge px-2 py-1 rounded-pill mb-1 fs-7 me-1'
                            style={{border: '2px solid #E1E1E1'}}
                          >
                            {framework}
                          </span>
                        ))}
                      <span className='fw-normal fw-bold mx-2 fs-6'>
                        <span
                          className={`badge fs-7 ${
                            test.status === 'Deactivated' ? 'text-dark text-bold m-1' : ''
                          }`}
                          style={{
                            color:
                              test.status === 'Deactivated'
                                ? '#5A5A5A'
                                : test.status === 'Pass'
                                ? '#0E9F6E'
                                : '#EE3043',
                            background:
                              test.status === 'Deactivated'
                                ? '#F6F6F6'
                                : test.status === 'Pass'
                                ? '#E8F8F4'
                                : '#FFF5F8',
                          }}
                        >
                          {' '}
                          {test.status === 'Deactivated'
                            ? 'Deactivated'
                            : test.status === 'Pass'
                            ? 'Passing'
                            : 'Failing'}
                        </span>
                      </span>
                      <span className='mx-1'> </span>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-3'>
                    {currentUser?.role !== 'Auditor' &&
                      selectedTest[0] &&
                      (selectedTest[0].status === 'Deactivated' ? (
                        <Button
                          btnType='default'
                          onClick={() => handleOpenTestModal(selectedTest[0])}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='#5A5A5A'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='icon icon-tabler icons-tabler-outline icon-tabler-eye me-2'
                            style={{marginRight: '4px'}}
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                            <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                          </svg>
                          Activate
                        </Button>
                      ) : (
                        <Button btnType='default' onClick={handleDeactivateClick}>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='#5A5A5A'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='icon icon-tabler icons-tabler-outline icon-tabler-eye-off me-2'
                            style={{marginRight: '4px'}}
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M10.585 10.587a2 2 0 0 0 2.829 2.828' />
                            <path d='M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87' />
                            <path d='M3 3l18 18' />
                          </svg>
                          Deactivate
                        </Button>
                      ))}
                    {test.type === 'Document' && (
                      <Button
                        btnType='primary'
                        onClick={handleAddFileClick}
                        disabled={currentUser?.role === 'Auditor' || test.status === 'Deactivated'}
                      >
                        Add File
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              <div className='  mt-4'>
                <div className='d-flex  h-55px'>
                  <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
                    <li className='nav-item'>
                      <Link
                        to={`/tests/details/${id}`}
                        className={`nav-link me-6 ${
                          activeTab === 'overview' ? 'text-active-primary active' : ''
                        }`}
                        onClick={() => handleTabClick('overview')}
                      >
                        Overview
                      </Link>
                    </li>

                    {currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus' && (
                      <li className='nav-item'>
                        <Link
                          to={`/tests/details/${id}`}
                          className={`nav-link me-6 ${
                            activeTab === 'controls' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('controls')}
                        >
                          Linked Controls
                        </Link>
                      </li>
                    )}

                    <li className='nav-item'>
                      <Link
                        to={`/tests/details/${id}`}
                        className={`nav-link me-6 ${
                          activeTab === 'notes' ? 'text-active-primary active' : ''
                        }`}
                        onClick={() => handleTabClick('notes')}
                      >
                        Notes
                      </Link>
                    </li>

                    {/* <li className='nav-item'>
                      <Link
                        to={`/tests/details/${id}`}
                        className={`nav-link me-6 ${activeTab === 'tasks' ? 'text-active-primary active' : ''
                          }`}
                        onClick={() => handleTabClick('tasks')}
                      >
                        Tasks
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            {activeTab === 'overview' && (
              <>
                {(test.type === 'platform' || test.type === 'Platform') && test.automated_type === true && (
                  <div className='card mb-4 mt-4'>
                    <div className='card-header border-1 d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <h3 className='fw-bold text-gray-900 fs-4'>Test Results</h3>
                      </div>
                      <div className='fs-7 badge badge-light-primary m-0'>
                        Automated
                      </div>
                    </div>

                    <div className='card-body'>
                      <div className='d-flex align-items-center'>
                        {test.status === 'Pass' ? (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='currentColor'
                            className='icon icon-tabler icons-tabler-filled icon-tabler-circle-check text-success'
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z' />
                          </svg>
                        ) : (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='currentColor'
                            className='icon icon-tabler icons-tabler-filled icon-tabler-xbox-x text-danger'
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m3.6 5.2a1 1 0 0 0 -1.4 .2l-2.2 2.933l-2.2 -2.933a1 1 0 1 0 -1.6 1.2l2.55 3.4l-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2 -2.933l2.2 2.933a1 1 0 0 0 1.6 -1.2l-2.55 -3.4l2.55 -3.4a1 1 0 0 0 -.2 -1.4' />
                          </svg>
                        )}
                        <div className='d-flex flex-column ms-4'>
                          <span className='fw-bold text-gray-900 fs-6'>
                            {test.status === 'Pass' ? 'Passing' : 'Failing'}
                          </span>
                          <span className='text-gray-700 fs-7'>
                            Last evaluated: {test.updated_at ? new Date(test.updated_at).toLocaleDateString() : 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className='card mb-5 mb-xl-8 p-6 mt-8'>
                  <div className='text-grey-800 fw-semibold fs-6 mb-6 '>
                    <div
                      className='fv-row mb-4 text-gray-800 fs-6'
                      dangerouslySetInnerHTML={{__html: test.description}}
                    />
                  </div>

                  <div className='row g-5 g-xxl-6'>
                    <div className='col-md-6'>
                      <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                        CATEGORY
                      </h4>
                      <p className='text-grey-800 fw-semibold'>{test.category}</p>

                      <h4 className='fw-bold fs-6' style={{color: '#5E6274'}}>
                        STATUS
                      </h4>
                      <p className='text-grey-800 fw-semibold'>
                        {' '}
                        <span className='fw-normal fs-6 '>
                          <span className='fw-semibold'>
                            <span className='fw-semibold'>
                              {test.type === 'Document'
                                ? test.status === 'Deactivated'
                                  ? 'Deactivated'
                                  : test.files && test.files.length > 0
                                  ? 'OK'
                                  : 'Failing'
                                : test.status === 'Deactivated'
                                ? 'Deactivated'
                                : policies.length > 0
                                ? 'OK'
                                : 'Failing'}
                            </span>
                          </span>{' '}
                        </span>
                      </p>
                      <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                        OWNER
                      </h4>
                      <p className='text-grey-800 fw-semibold'>
                        <span className='fw-normal'>
                          {' '}
                          <select
                            name='group'
                            className='form-select w-40 py-2 px-4'
                            data-control='select2'
                            style={{width: '200px'}}
                            data-placeholder='Select Group'
                            value={newOwner || test.owner}
                            onChange={handleOwner}
                            disabled={
                              currentUser?.role === 'Auditor' || test.status === 'Deactivated'
                            }
                          >
                            <option value='' defaultChecked>
                              Assign Owner
                            </option>
                            {personnels
                              .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                              .map((group) => (
                                <option key={group.id} value={group.full_name}>
                                  {group.full_name}
                                </option>
                              ))}
                          </select>
                        </span>
                      </p>
                    </div>
                    <div className='col-md-6'>
                      <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                        FRAMEWORKS MAPPED
                      </h4>
                      <p className='text-grey-800 fw-semibold'>
                        {test.framework
                          .split(', ')
                          .filter((framework) =>
                            activeFrameworks.some((item) => framework.startsWith(item))
                          )
                          .map((framework, index) => (
                            <span
                              key={index}
                              className='badge px-2 py-1 rounded-pill mb-1 fs-7 me-1'
                              style={{border: '2px solid #E1E1E1'}}
                            >
                              {framework}
                            </span>
                          ))}
                      </p>

                      {test.automated_type && (
                        <>
                          <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                            INTEGRATION
                          </h4>
                          <p className='text-grey-800 fw-semibold'>{test.integration}</p>

                          <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                            UPDATED
                          </h4>
                          <p className='text-grey-800 fw-semibold d-flex align-items-center gap-3'>
                            {FormatTimestamp({timestamp: test.updated_at})}{' '}
                            <span 
                              style={{cursor: isRefreshingTest ? 'not-allowed' : 'pointer'}} 
                              onClick={isRefreshingTest ? undefined : handleRefreshTest}
                            >
                              {isRefreshingTest ? (
                                <div className='spinner-border spinner-border-sm' role='status'>
                                  <span className='visually-hidden'>Loading...</span>
                                </div>
                              ) : (
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  stroke='currentColor'
                                  strokeWidth='2'
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                  className='icon icon-tabler icons-tabler-outline icon-tabler-refresh'
                                >
                                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                  <path d='M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4' />
                                  <path d='M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4' />
                                </svg>
                              )}
                            </span>
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className='modal-footer'>
                  <div className='mt-2 w-100'>
                    {test.type === 'Document' ? (
                      <>
                        {!test.files || test.files.length === 0 ? (
                          <>
                            <span className='text-gray-800 fw-semibold me-2 fs-6 mb-4'>
                              Evidences
                            </span>
                            <UploadFile
                              onFileUpload={handleFileUpload}
                              fid={test.id}
                              testName={test.name}
                              status={test.status}
                              isOpen={showUploadFile}
                            />
                          </>
                        ) : (
                          <>
                            {showUploadFile && (
                              <UploadFile
                                onFileUpload={handleFileUpload}
                                fid={test.id}
                                testName={test.name}
                                // selectedTimeframe={timeframe}
                                status={test.status}
                                isOpen={showUploadFile}
                              />
                            )}

                            <div>
                              {test.files &&
                                test.files.map((file, fileIndex) => (
                                  <>
                                    <div className='d-flex align-items-center mb-3 mt-4 mx-1'>
                                      <i className='ki-duotone ki-file fs-1'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                      </i>
                                      <div className='d-flex justify-content-between align-items-center flex-grow-1 '>
                                        <div className='mx-2 fw-bold fs-5 '>
                                          Document #{fileIndex + 1}
                                        </div>
                                      </div>
                                    </div>

                                    <div className='card m-1 mb-3 p-2' key={fileIndex}>
                                      <div className='mx-4  d-flex align-items-center'>
                                        <p className='fw-bold fs-5 mb-0'>{file.name}</p>
                                        <span className='badge border p-2 rounded-pill ms-auto'>
                                          <span
                                            className={`badge border rounded-circle  bg-primary`}
                                            style={{
                                              width: '12px',
                                              height: '12px',
                                              padding: '3px',
                                            }}
                                          >
                                            {' '}
                                          </span>{' '}
                                          <span className='text-center fw-bold text-muted mx-2'>
                                            Uploaded
                                          </span>
                                        </span>
                                        <div className='dropdown'>
                                          <button
                                            className='btn btn-secondary border-0 p-0 m-2'
                                            type='button'
                                            id='dropdownMenu2'
                                            data-bs-toggle='dropdown'
                                            aria-haspopup='true'
                                            aria-expanded='false'
                                            disabled={
                                              currentUser?.role === 'Auditor' ||
                                              test.status === 'Deactivated'
                                            }
                                          >
                                            <img
                                              src='/media/buttons/Options.svg'
                                              alt='Options'
                                              onClick={toggleDropdown}
                                            />
                                          </button>
                                          <ul
                                            className='dropdown-menu dropdown-menu-end'
                                            aria-labelledby='dropdownMenu2'
                                          >
                                            <li>
                                              <button
                                                className='dropdown-item text-muted text-hover-primary'
                                                type='button'
                                                onClick={() => handleViewClick(file)}
                                              >
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='18'
                                                  height='18'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  stroke='currentColor'
                                                  stroke-width='2'
                                                  stroke-linecap='round'
                                                  stroke-linejoin='round'
                                                  className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-2'
                                                >
                                                  <path
                                                    stroke='none'
                                                    d='M0 0h24v24H0z'
                                                    fill='none'
                                                  />
                                                  <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                                  <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                                </svg>
                                                View
                                              </button>
                                            </li>
                                            <li>
                                              <button
                                                className='dropdown-item text-muted text-hover-primary '
                                                type='button'
                                                onClick={(e) => handleDownloadClick(file)}
                                              >
                                                <img
                                                  src='/media/buttons/download.svg'
                                                  alt=''
                                                  className='m-1 mx-1'
                                                  style={{width: '20px', height: '20px'}}
                                                />
                                                Download
                                              </button>
                                            </li>

                                            <li>
                                              <button
                                                className='dropdown-item text-danger text-hover-primary'
                                                type='button'
                                                onClick={(e) => handleDeleteClick(file)}
                                              >
                                                <i className='fas fa-trash mx-2 text-danger'></i>{' '}
                                                Remove
                                              </button>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <p className='mx-4 d-flex align-items-center'>
                                        Recurrence start: {formatDate(file.date)} |{' '}
                                        <div className='symbol symbol-20px mx-2 rounded-circle'>
                                          {test.owner ? (
                                            test.owner_uid ? (
                                              <OwnerDisplay owner={test.owner} uid={test.owner_uid}/>
                                            ) : (
                                              <div className='symbol symbol-25px'>
                                                <span
                                                  className='symbol-label fs-7 fw-bold'
                                                  style={{
                                                    backgroundColor: '#F5F5F5',
                                                    border: '1px solid #E5E5E5',
                                                  }}
                                                >
                                                  {test.owner
                                                    ? (() => {
                                                        const nameParts = test.owner.split(' ')
                                                        if (nameParts.length > 1) {
                                                          return `${nameParts[0]
                                                            .charAt(0)
                                                            .toUpperCase()}`
                                                        } else {
                                                          return `${nameParts[0]
                                                            .charAt(0)
                                                            .toUpperCase()}`
                                                        }
                                                      })()
                                                    : ''}
                                                </span>
                                              </div>
                                            )
                                          ) : <div>Not assigned</div>}
                                        </div>{' '}
                                        {/* {test.owner || 'Not assigned'}{' '} */}
                                      </p>
                                    </div>
                                  </>
                                ))}
                            </div>
                          </>
                        )}
                      </>
                    ) : !((test.type === 'platform' || test.type === 'Platform') && test.automated_type === true) ? (
                      <>
                        <a
                          href={`https://app.getsecureslate.com/policy-library/lists?policies=${test.policies}`}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <div className={`card mb-5 mb-xl-8 `}>
                            <div
                              className='card-header border-0 pt-6 mb-5'
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <>
                                <div className='d-flex align-items-center'>
                                  <div className='d-flex justify-content-start flex-column'>
                                    <span className='card-label fw-bold fs-6'>How to fix</span>
                                    <span className='text-gray-700 fw-semibold fs-7 d-none d-md-block my-2'>
                                      Create and approve a {test.name}for your business using the
                                      templates included in our{' '}
                                      <a
                                        href={`https://app.getsecureslate.com/policy-library/lists?policies=${test.policies}`}
                                        target='_blank'
                                        rel='noreferrer'
                                      >
                                        policy library
                                      </a>
                                      .
                                    </span>
                                  </div>
                                </div>
                              </>
                            </div>
                          </div>
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              </>
            )}

            {activeTab === 'controls' && (
              <ControlSection
                selectedTest={selectedTest}
                currentUser={currentUser}
                activeFrameworks={activeFrameworks}
              />
            )}

            {activeTab === 'notes' && (
              <>
                <div className='mb-8 mt-8'>
                  <div className='d-flex align-items-center mb-8'>
                    <textarea
                      className='form-control me-2'
                      placeholder='Leave a note'
                      name='notes'
                      value={noteInput}
                      onChange={(e) => setNoteInput(e.target.value)}
                    />
                    {isAdding ? (
                      <Button btnType='primary' disabled>
                        Adding...{' '}
                        <span className='spinner-border spinner-border-sm align-middle m-2'></span>
                      </Button>
                    ) : (
                      <Button btnType='primary' onClick={handleNotes} disabled={!noteInput.trim()}>
                        Add Note
                      </Button>
                    )}
                  </div>
                  {tests && tests.length > 0 ? (
                    tests
                      .filter((control) => control.id === id)
                      .map((control) => {
                        const filteredNotes = control.notes
                          ? control.notes.filter((note) => {
                              if (currentAuditContext?.auditId) {
                                return note.auditId === currentAuditContext.auditId
                              }
                              if (currentUser?.role === 'Auditor' && audits.length > 0) {
                                return note.auditId === audits[0]?.id
                              }
                              return !note.auditId
                            })
                          : []

                        return filteredNotes.length > 0 ? (
                          filteredNotes.map((note, index) => (
                            <div className='mt-4 mb-8' key={index}>
                              <div className='d-flex align-items-center justify-content-between mb-2'>
                                <div className='d-flex align-items-center'>
                                  <div className='symbol symbol-40px me-3'>
                                    {note.addedUser ? (
                                      <span
                                        className='symbol-label fs-7 fw-bold'
                                        style={{
                                          backgroundColor: '#F5F5F5',
                                          border: '1px solid #E5E5E5',
                                          borderRadius: '50%',
                                        }}
                                      >
                                        {note.addedUser
                                          ? note.addedUser.trim().charAt(0).toUpperCase()
                                          : ''}
                                      </span>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </div>

                                  <div className='d-flex flex-column'>
                                    {(() => {
                                      const personnel = personnels.find(
                                        (p) =>
                                          p.id === note.addedUserUid || p.uid === note.addedUserUid
                                      )
                                      return (
                                        <span className='text-dark fw-bold fs-6'>
                                          {note.addedUser}
                                          {personnel && personnel.role && (
                                            <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                                              {personnel.role}
                                            </span>
                                          )}
                                        </span>
                                      )
                                    })()}
                                    <span className='text-gray-600 fw-semibold text-muted d-block fs-7'>
                                      {note.addedDate} {note.addedTime}
                                    </span>
                                  </div>
                                </div>

                                <div className='dropdown'>
                                  {currentUser?.uid === note?.addedUserUid && (
                                    <button
                                      className='btn btn-secondary border-0 p-0 m-2'
                                      type='button'
                                      id='dropdownMenu2'
                                      data-bs-toggle='dropdown'
                                      aria-haspopup='true'
                                      aria-expanded='false'
                                    >
                                      <img
                                        src='/media/buttons/Options.svg'
                                        alt='Options'
                                      />
                                    </button>
                                  )}
                                  <ul
                                    className='dropdown-menu dropdown-menu-end'
                                    aria-labelledby='dropdownMenu2'
                                  >
                                    <li>
                                      <button
                                        className='dropdown-item text-hover-primary '
                                        type='button'
                                        style={{color: '#262626'}}
                                        onClick={() => handleEditNote(index, note.note)}
                                      >
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          stroke='currentColor'
                                          stroke-width='2'
                                          stroke-linecap='round'
                                          stroke-linejoin='round'
                                          className='icon icon-tabler icons-tabler-outline icon-tabler-edit mx-2 mb-1'
                                        >
                                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                          <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                                          <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                                          <path d='M16 5l3 3' />
                                        </svg>
                                        Edit
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='dropdown-item text-danger'
                                        type='button'
                                        onClick={() => handleDeleteNote(index)}
                                      >
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          stroke='currentColor'
                                          stroke-width='2'
                                          stroke-linecap='round'
                                          stroke-linejoin='round'
                                          className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                        >
                                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                          <path d='M4 7l16 0' />
                                          <path d='M10 11l0 6' />
                                          <path d='M14 11l0 6' />
                                          <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                          <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                        </svg>
                                        Delete
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              {editingNoteIndex === index ? (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                  <textarea
                                    value={editedNoteContent}
                                    onChange={(e) => setEditedNoteContent(e.target.value)}
                                    className='form-control'
                                  />
                                  <div
                                    className='d-flex justify-content-end w-100 mt-2 gap-2'
                                    style={{width: '100%'}}
                                  >
                                    <Button
                                      btnType='secondary'
                                      onClick={() => setEditingNoteIndex(null)}
                                    >
                                      Close
                                    </Button>
                                    <Button btnType='primary' onClick={handleSaveEditedNote}>
                                      {noteSaving ? (
                                        <>
                                          Saving...
                                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </>
                                      ) : (
                                        'Save'
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                <div className='card p-4 mb-4 mt-2'>
                                  <span className='d-block fs-6 text-gray-900'>
                                    <div>{note.note}</div>
                                  </span>
                                </div>
                              )}
                            </div>
                          ))
                        ) : (
                          <div key='no-notes'></div>
                        )
                      })
                  ) : (
                    <div></div>
                  )}
                </div>
              </>
            )}

            <AddTask isOpen={isModalOpen} onClose={handleCloseModal} test_id={id ?? ''} />

            {activeTab === 'tasks' && (
              <>
                <div className='my-8 d-flex justify-content-between'>
                  <div className=''>
                    <div className='fs-6 fw-bold mb-2'>Task List</div>
                    <span>Assign tasks that might fix this control to team members.</span>
                  </div>
                  <button
                    onClick={handleOpenModal}
                    className='btn btn-sm '
                    onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                      (e.currentTarget.style.backgroundColor = '#148363')
                    }
                    onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                      (e.currentTarget.style.backgroundColor = '#0E9F6E')
                    }
                    disabled={currentUser?.role === 'Auditor'}
                    style={{
                      backgroundColor: '#0E9F6E',
                      color: '#fff',
                      width: '110px',
                      height: '40px',
                      borderRadius: '4px',
                      marginRight: '15px',
                      transition: 'background-color 0.3s',
                    }}
                  >
                    Add Task
                  </button>
                </div>
                <div className='card p-3 mt-4'>
                  {/* begin::Table container */}
                  <div
                    className='table-responsive'
                    style={{minHeight: '300px', maxHeight: '500px', overflowY: 'auto'}}
                  >
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                                checked={allTaskMarkAsCompleted}
                                onChange={handleAllMarkAsCompleteClicked}
                              />
                            </div>
                          </th>
                          <th className='min-w-200px'>Task</th>
                          <th className='min-w-50px'>Priority</th>
                          <th className='min-w-100px'>Assigned To</th>
                          {/* <th className='min-w-100px'>Due date</th> */}
                          <th className='min-w-50px text-end'></th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {tasks.map((task) => (
                          <tr key={task.id}>
                            <td>
                              <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input
                                  className='form-check-input widget-9-check'
                                  type='checkbox'
                                  checked={task.checked}
                                  onChange={() =>
                                    handleMarkAsCompleteClicked(task.id, !task.checked)
                                  }
                                />
                              </div>
                            </td>

                            <td>
                              <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                {task.taskName}
                              </div>
                            </td>

                            <td>
                              <span
                                className={`badge fs-7 ${
                                  task.priority === 'High'
                                    ? 'badge-danger'
                                    : task.priority === 'Medium'
                                    ? 'badge-warning'
                                    : 'badge-primary'
                                }`}
                                style={{
                                  color:
                                    task.priority === 'High'
                                      ? '#EE3043'
                                      : task.priority === 'Medium'
                                      ? '#FFA800'
                                      : '#0E9F6E',
                                  background:
                                    task.priority === 'High'
                                      ? '#FFF5F8'
                                      : task.priority === 'Medium'
                                      ? '#FFF8DD'
                                      : '#E8F8F4',
                                }}
                              >
                                {task.priority}
                              </span>
                            </td>
                            <td>
                              <div className='d-flex align-items-center'>
                                {task.owner ? (
                                  <>
                                    <div className='symbol symbol-35px me-3'>
                                      <span
                                        className='symbol-label fs-7 fw-bold'
                                        style={{backgroundColor: '#DAF9EF'}}
                                      >
                                        {task.owner
                                          ? (() => {
                                              const nameParts = task.owner.split(' ')
                                              if (nameParts.length > 1) {
                                                return `${nameParts[0]
                                                  .charAt(0)
                                                  .toUpperCase()}${nameParts[1]
                                                  .charAt(0)
                                                  .toUpperCase()}`
                                              } else {
                                                return `${nameParts[0]
                                                  .charAt(0)
                                                  .toUpperCase()}${nameParts[0]
                                                  .charAt(1)
                                                  .toUpperCase()}`
                                              }
                                            })()
                                          : ''}
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <div className='text-dark fw-semibold text-hover-primary fs-6'>
                                        {task.owner}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <span>-</span>
                                  </>
                                )}
                              </div>
                            </td>

                            {/* <td className='fs-6 fw-semibold'>{task.duedate}</td> */}
                            <td className='text-end'>
                              <div className='dropdown '>
                                <button
                                  className='btn btn-secondary border-0 p-0 '
                                  type='button'
                                  id='dropdownMenu2'
                                  data-bs-toggle='dropdown'
                                  aria-haspopup='true'
                                  aria-expanded='false'
                                >
                                  <img
                                    src='/media/buttons/Options.svg'
                                    alt='Options'
                                    // onClick={toggleDropdown}
                                  />
                                </button>
                                <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
                                  <li>
                                    <button
                                      className='dropdown-item'
                                      type='button'
                                      onClick={() => handleMarkAsCompleteClicked(task.id, true)}
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='18'
                                        height='18'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='#5E6274'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        className='icon icon-tabler icons-tabler-outline icon-tabler-check mx-1 mb-1'
                                      >
                                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                        <path d='M5 12l5 5l10 -10' />
                                      </svg>{' '}
                                      Mark as complete
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className='dropdown-item'
                                      style={{color: '#F15363'}}
                                      type='button'
                                      onClick={() => handleRemoveTask(task.id)}
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='18'
                                        height='18'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='#F15363'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                                      >
                                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                        <path d='M4 7l16 0' />
                                        <path d='M10 11l0 6' />
                                        <path d='M14 11l0 6' />
                                        <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                        <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                      </svg>{' '}
                                      Remove task
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </>
        ))
      ) : (
        <>
          {' '}
          <div style={{height: '80vh', display: 'flex', flexDirection: 'column'}}>
            {' '}
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer />
      {isDeleteModalOpen && (
        <ConfirmationModal
          isModalOpen={isDeleteModalOpen}
          hideModal={() => setIsDeleteModalOpen(false)}
          confirmBtnClickHandler={handleConfirmDelete}
          toDeleteItemTitle={selectedFile?.name}
          isLoading={isDeleting}
          confirmButtonText='Remove'
          type='delete'
        />
      )}
      <ConfirmationModal
        isModalOpen={isNoteDeleteModalOpen}
        hideModal={() => setIsNoteDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmNoteDelete}
        title='Delete Note'
        message='Are you sure you want to delete this note?'
        isLoading={isDeleting}
        type='delete'
      />
      <Deactivate
        isOpen={isDeactivateOpen}
        onClose={handleDeactivateClose}
        id={id ?? ''}
        type='test'
        title='test'
      />
      <ConfirmationModal
        isModalOpen={isTestModalOpen}
        hideModal={handleCloseTestModal}
        confirmBtnClickHandler={handleConfirmTestActivateDeactivate}
        toDeleteItemTitle={selectedTest?.[0]?.name || ''}
        isLoading={isProcessingTest}
        type={selectedTest?.[0]?.status === 'Deactivated' ? 'activate' : 'deactivate'}
        title={`${selectedTest?.[0]?.status === 'Deactivated' ? 'Activate' : 'Deactivate'} Test`}
        message={`Are you sure you want to ${
          selectedTest?.[0]?.status === 'Deactivated' ? 'activate' : 'deactivate'
        } ${selectedTest?.[0]?.name || 'this test'}?`}
        confirmButtonText={`Yes, ${
          selectedTest?.[0]?.status === 'Deactivated' ? 'activate' : 'deactivate'
        }`}
      />
      <DocumentViewerModal
        show={isDocumentViewerOpen}
        onClose={() => {
          setIsDocumentViewerOpen(false)
          setSelectedDocument(null)
        }}
        file={selectedDocument}
      />
      <ConfirmationModal
        isModalOpen={isTaskRemoveModalOpen}
        hideModal={() => setIsTaskRemoveModalOpen(false)}
        confirmBtnClickHandler={handleConfirmTaskRemove}
        title="Remove Selected Items"
        message="Are you sure you want to remove the selected items? This action cannot be undone."
        confirmButtonText="Remove"
        type="delete"
        isLoading={isRemovingTask}
      />
    </>
  )
}

export default DetailsTest
